import { DeviceInfo } from '../DeviceInfo';
import { EmailInfo } from '../EmailInfo';

export class SendEmailDocumentReadyEventArgs extends EmailInfo {
    public deviceInfo: DeviceInfo;
    public url: string;
    public handled: boolean = false;

    constructor(emailInfo: EmailInfo, deviceInfo: DeviceInfo, url: string) {
        super();

        this.body = emailInfo.body;
        this.cc = emailInfo.cc;
        this.format = emailInfo.format;
        this.from = emailInfo.from;
        this.subject = emailInfo.subject;
        this.to = emailInfo.to;
        this.deviceInfo = deviceInfo;
        this.url = url;
    }
}
